import { StoreKey } from "@common/constans";
import { StorageType } from "@common/enum";
import { MessageBox, MessageBoxBtnGroup } from "@components/general/MessageBox";
import { Culture } from "@core/Culture";
import { IAppState } from "@misc/State";
import Storage from "@service/Storage";
import Translate from "@service/Translate";
import { clearStoreForSearch } from "@utilize/Util";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";

var bookingTransactionTimer: NodeJS.Timer;
const BookingTransactionTimeout: FC = () => {
    const { tr, re } = Translate;
    const { bookingTransactionTimeout, searchMode } = useSelector((state: IAppState) => ({ bookingTransactionTimeout: state.bookingTransactionTimeout, searchMode: state.searchMode }));
    const [showTimeoutMessage, setShowTimeoutMessage] = useState(false);

    useEffect(() => {
        if (bookingTransactionTimeout.start) {
            const start = Culture.getDateTimeInstance().getTime();
            const timeout = Storage.get<number>(StoreKey.BookingTransactionTimeout, StorageType.Session) || bookingTransactionTimeout.timeout || 0;
            clearInterval(bookingTransactionTimer);
            bookingTransactionTimer = setInterval(() => {
                const now = Culture.getDateTimeInstance().getTime();
                const diff = now - start;
                Storage.set<number>(StoreKey.BookingTransactionTimeout, timeout - diff, StorageType.Session);
                if (diff > timeout) {
                    setShowTimeoutMessage(true);
                    clearInterval(bookingTransactionTimer);
                }
            }, 1000);
        }
        else {
            clearInterval(bookingTransactionTimer);
            Storage.remove(StoreKey.BookingTransactionTimeout, StorageType.Session);
        }
    }, [bookingTransactionTimeout]);

    const onAction = () => {
        setShowTimeoutMessage(false);
        if (bookingTransactionTimeout.btnAction)
            bookingTransactionTimeout.btnAction();
        else
            clearStoreForSearch(searchMode, false);
    }

    return (
        <div className="transaction-timeout">
            <MessageBox
                btnGroup={MessageBoxBtnGroup.Research}
                show={showTimeoutMessage}
                title={tr("transaction_timeout_dialog_title")}
                onAction={onAction}
            >
                <span className="text">{re("msg_transaction_timeout_description", <br />)}</span>
            </MessageBox>
        </div>
    );
}

export default BookingTransactionTimeout;